import { Alert, AlertTitle } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import ServiceProductItem from "./ServiceProductItem";
import { ServiceProduct, ServiceProductWithSolution } from "./types";

interface ServiceProductListProps {
  serviceProducts: (ServiceProduct | ServiceProductWithSolution)[];
  onClick: (id: string) => void;
}

const useStyles = makeStyles(theme => ({
  container: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, 400px)",
    gap: 24,
    boxSizing: "border-box",
    alignItems: "start",
    padding: 0,
    margin: 0,
    justifyContent: "start",
    height: "auto",
    alignSelf: "flex-start",
    maxHeight: "calc(100vh - 150px)",
    overflow: "auto"
  },
  infoContainer: {
    padding: theme.spacing(2),
    border: "solid 1px #dcdcdc",
    width: "100%",
    marginTop: theme.spacing(2)
  }
}));

const ServiceProductList: React.FC<ServiceProductListProps> = ({
  serviceProducts,
  onClick
}) => {
  const classes = useStyles();

  return serviceProducts.length > 0 ? (
    <div className={classes.container}>
      {serviceProducts.map(serviceProduct => (
        <div key={serviceProduct.id} style={{ margin: 0, padding: 0 }}>
          <ServiceProductItem
            serviceProduct={serviceProduct}
            onClick={onClick}
          />
        </div>
      ))}
    </div>
  ) : (
    <Alert severity="info" className={classes.infoContainer}>
      <AlertTitle>No Service Products Available</AlertTitle>
      There are currently no service products available. As a result, the
      services within this solution will not be accessible from any API Key
      until a service product is created. Please create the necessary service
      products to grant access to the required services.
    </Alert>
  );
};

export default ServiceProductList;
